import { useQuery } from "@tanstack/react-query";

import FetchClients from "../client";

const providers = {
  useQueryAll,
} as const;

export default providers;

const UTILITY_PROVIDERS_KEY = "arcadia/providers";

function useQueryAll() {
  return useQuery({
    queryKey: [UTILITY_PROVIDERS_KEY],

    queryFn: async () => {
      const { data, error } = await FetchClients.arcadia.GET("/providers", {});
      if (data) return data;
      throw new Error(error);
    },
  });
}
